import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import BCDevHero from "./BCDevHero";
import BlockCDevS from "./BlockCDevS";
import BlockchainMOutlook from "./BlockchainMOutlook";
import Consultation from "./Consultation";
import Utilize from "./Utilize";

function BlockchainDevelopment() {
  return (
    <div>
      <Header />
      <BCDevHero />
      <BlockCDevS />
      <Consultation />
      <Utilize />
      {/* <BlockchainMOutlook /> */}
      <Footer />
    </div>
  );
}

export default BlockchainDevelopment;
